import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';

export const getUtilitiesFiltersConfigByType = (type: string): IFilterConfigItem[] => [
  {
    title: 'Power Provider',
    name: `${type}_power_provider`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Power Service Amps',
    name: `${type}_power_service_amps`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Power Service Volts',
    name: `${type}_power_service_volts`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Power Service Phase & Wire',
    name: `${type}_power_service_phase`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Water Provider',
    name: `${type}_water_provider`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Water Service',
    name: `${type}_water_service`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Sanitation / Sewer Provider',
    name: `${type}_sanitation_provider`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Sanitation / Sewer Service',
    name: `${type}_sanitation_service`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Gas Provider',
    name: `${type}_gas_provider`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Gas Service',
    name: `${type}_gas_service`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Broadband Provider',
    name: `${type}_broadband_provider`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Broadband Service',
    name: `${type}_broadband_service`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
  {
    title: 'Utility Comments',
    name: `${type}_utility_comments`, // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.utilities,
  },
]
